//#region  OLD switch code 
// switch (optionsType) {
//     case 'agent':
//     case 'agent-all':
//     case 'borrower':
//     case 'buyer':
//     case 'seller':
//     case 'team':
//         return option ? formatName(option) : '';
//     case 'firm':
//     case 'tenant':
//     case 'lender':
//         return option ? option.NAME : '';
//     case 'territory':
//         return option ? option.AGENT_NAME : '';
//     default:
//         if(option==='UPLOADS'){
//             return 'UPLOAD';
//         }
//         return option ? (optionLabelKey ? option[optionLabelKey] : optionKey ? option[optionKey] : option) : '';
// }
//#endregion


import React from 'react';
import PropTypes from 'prop-types';
import {Autocomplete, createFilterOptions} from "@material-ui/lab";
import {TextField, Chip} from "@material-ui/core";
import {getOptionsType} from './optionTypes';
import {formatName, formatNames, sortArray} from '../../utils';
import removeCircle from '../../svgs/removeCircle.svg';
import arrow from '../../svgs/Arrow.svg';
import close from '../../svgs/X.svg';
import Input from "../Input-new/Input";

require('./Dropdown.scss');

const defaultFilterOptions = createFilterOptions();
const percentDecimals = 2;

const Dropdown = ({dropdownType = 'single', inputMode = false, options, optionsType, optionKey, optionLabelKey, value, valueKey, percentKey, firmName, label, percentLabel, data, hasAgentPercent, handleParentChange, handleInputParentChange, disabled = false, viewMode = false, groupBy = false, addNewItem, withAddNew, isFilter = false, theme = 'default', placeholder, hasDrawer, isFromProperty = false, deleted = false, typeKey, typeValue, fillText=null, getSelectedOption, className = '', viewClassName = '', id, index, isOffMarket=false, tooltip, tooltipPosition='up', handleInputFocus, openOnFocus=false, required,isSeniorAgent,client={},customValues=false,autoSelect=false,vendorData=[], selectedTeamMembers=[]}) => {
    let optionList = options ? options : isSeniorAgent ? getOptionsType(optionsType, data.source) : getOptionsType(optionsType,client,vendorData);
    // const getOptionLabel = (option) => {
    //     if (option && option.type === 'div')
    //         return option;

    //     switch (optionsType) {
    //         case 'agent':
    //         case 'agent-all':
    //         case 'borrower':
    //         case 'buyer':
    //         case 'seller':
    //             return option ? formatName(option) : '';
    //         case 'team':
    //             return option ? formatNames(option) : '';
    //         case 'firm':
    //         case 'tenant':
    //         case 'lender':
    //             return option ? option.NAME : '';
    //         case 'territory':
    //             return option ? option.AGENT_NAME !== null ? option.AGENT_NAME : '' : '';
    //         default:
    //             if(option==='UPLOADS'){
    //                 return 'UPLOAD';
    //             }
    //             return option ? (optionLabelKey ? option[optionLabelKey] : optionKey ? option[optionKey] : option) : '';
    //     }
    // };

    const getOptionLabel = (option) => {
        const label = getRawOptionLabel(option);
        // The 'no results' sentinel is a React element and is rendered as-is; everything else
        // must be a string, otherwise MUI's filter/highlight code calls .toLowerCase() on null.
        if (label && label.type === 'div') return label;
        return typeof label === 'string' ? label : '';
    };

    const getRawOptionLabel = (option) => {
        if (!option) return ''; // Handle null or undefined options gracefully

        if (option.type === 'div') {
            return option;
        }

        switch (optionsType) {
            case 'firm':
                if (typeof option === 'string') return option; // freeSolo typed value
                return option.name || option.NAME || ''; // Use NAME for these types
            case 'lender':
                return option.name ? option.name : ''; // Use NAME for these types
            case 'agent':
                return option ? formatNames(option) : ''
            case 'agent-all':
                return option ? formatNames(option) : ''
            case 'buyer':
            case 'seller':
            case 'invesstor':
                return option ? formatNames(option) : ''
            case 'borrower':
           
                return option ? formatNames(option) : ''; // Use AGENT_NAME for these types
    
            case 'team':
                return option ? formatNames(option) : '';
    
                case 'tenant':
                    return option.name ? option.name : '';
    
            case 'title-company':
                if (typeof option === 'string') {
                    return option.length && option !== 'Other' ? `${option.slice(0, 70)}...` : option;
                }
                return '';
    
            default:
                if (option === 'UPLOADS') {
                    return 'UPLOAD';
                }
    
                if (optionLabelKey && option[optionLabelKey] !== undefined) {
                    return String(option[optionLabelKey]); // Use optionLabelKey if specified
                }
    
                if (optionKey && option[optionKey] !== undefined) {
                    return String(option[optionKey]); // Use optionKey if specified
                }
    
                return String(option); // Fallback: return option as a string
        }
    };

    
//     const getValuesForDropdown = (data, options, optionKey, type = 'multiple') => { old code
//         if (!data || !options || !options.length) return [];
//         //let formattedQueryValues = data.ARCIMEDES_ROW_ID ? data.ARCIMEDES_ROW_ID : data.split(',');
//         let formattedQueryValues = (typeof data !== 'object' && !Array.isArray(data))? data :data.ARCIMEDES_ROW_ID ? data.ARCIMEDES_ROW_ID : data.split(',')
//         let response = [];
//  //added tostring below for converting formattedQueryValues
//  // options.forEach((el) => {
// //     if (!typeKey && (formattedQueryValues.includes(el) || formattedQueryValues.includes(el[optionKey]))
// //         || typeKey && formattedQueryValues.includes(el[optionKey]) && el.groupedBy === typeValue)
// //         response.push(el);
// // });
//         // options.forEach((el) => {
//         //     if (!typeKey && (formattedQueryValues.toString().includes(el[optionKey]) || formattedQueryValues.toString().includes(el))
//         //         || typeKey && formattedQueryValues.toString().includes(el[optionKey]) && el.groupedBy === typeValue)
//         //         response.push(el);
//         // });
//         if (!response)
//             response = [];
//         if (type === "single"){
//             response = response[0] ? response[0] : null;
//             if (inputMode) {
//                 response = data;
//             }
//         }
//         if (getSelectedOption)
//             getSelectedOption(response);

//         return response;
//     };


   
const getValuesForDropdown = (data, options, optionKey, type = 'multiple') => { // new code in response[0] the data is not in proper order issue facing in buyers-filter-agent field if selected id is more then 100
    if (!options || !options.length) {
        return type === 'single' ? null : [];
    }
    if (data === null || data === undefined || data === '') {
        return type === 'single' ? null : [];
    }
    // let formattedQueryValues =  (typeof data === 'string') ? data.split(',') : data && typeof data === 'object' ? (data.ARCIMEDES_ROW_ID ? data.ARCIMEDES_ROW_ID : []) : [];
// Normalize data into an array of string IDs
    let formattedQueryValues = [];
    if (typeof data === 'string' || typeof data === 'number') {
        formattedQueryValues = [String(data)];
    } else if (Array.isArray(data)) {
        formattedQueryValues = data.map(d => String(d));
    } else if (typeof data === 'object') {
        if (data.arcimedes_row_id !== undefined) {
            formattedQueryValues = [String(data.arcimedes_row_id)];
        } else if (data.ARCIMEDES_ROW_ID !== undefined) {
            formattedQueryValues = [String(data.ARCIMEDES_ROW_ID)];
        } else if (data[optionKey] !== undefined) {
            formattedQueryValues = [String(data[optionKey])];
        } else {
            formattedQueryValues = [];
        }
    }
    // if(formattedQueryValues === "gholley@highstcapital.com"){
    //     formattedQueryValues = "Greg Holley";
    // }
    let response = [];
    const formattedValuesStr = formattedQueryValues.toString(); // Convert to string for comparison
    // options.forEach((el) => {
    //     const isOptionKeyMatch = formattedValuesStr.includes(el[optionKey]);
    //     const isSimpleMatch = formattedValuesStr.includes(el);
    //     const isGroupedMatch = el.groupedBy === typeValue;
    //     if (
    //         (!typeKey && (isOptionKeyMatch || isSimpleMatch )) ||
    //         (typeKey && isOptionKeyMatch && isGroupedMatch) 
    //     ) {
    //         response.push(el);
    //     }
    // });

    // options.forEach((el) => { // initial changes
    //     const isOptionKeyMatch = formattedValuesStr.split(',').includes(String(el[optionKey] || el));
    //     const isSimpleMatch = formattedValuesStr.split(',').includes(String(el));
    //     const isGroupedMatch = el.groupedBy === typeValue;
   
    //     if ((!typeKey && (isOptionKeyMatch || isSimpleMatch)) ||
    //         (typeKey && isOptionKeyMatch && isGroupedMatch)) {
    //         response.push(el);
    //     }
    // });
    options.forEach((el) => { //when in the dropdown if we select any of status like hsc-status its taking status in th ui only and its will be same for same name included
        // A 'multiple' value is a comma-joined list of values; a 'single' value is one whole
        // value that can itself contain commas (e.g. "Anchor Church of McKinney, Inc"), so
        // splitting it would leave it matching no option and rendering blank in view mode.
        const formattedValues = type === 'multiple'
            ? formattedValuesStr.split(',')
            : [formattedValuesStr];
        const elValue = String(el[optionKey && optionKey.toLowerCase()] || el[optionKey && optionKey.toUpperCase()] || el); // Determine the key for matching
        const isOptionKeyMatch = formattedValues.includes(elValue); // Match using specified key
        const isSimpleMatch = formattedValues.includes(String(el.code)); // Explicitly match `code`
        const isGroupedMatch = el.groupedBy === typeValue; // Match grouping, if necessary
    
        // Adjusted conditions for precise matching
        if ((!typeKey && isOptionKeyMatch) || (typeKey && isOptionKeyMatch && isGroupedMatch)) {
            response.push(el);
        }
    });
  const reorderedData = response.length > 1
  ? response.sort((a, b) => {
      const aId = a.arcimedes_row_id || a.ARCIMEDES_ROW_ID;
      const bId = b.arcimedes_row_id || b.ARCIMEDES_ROW_ID;

      if (aId === formattedValuesStr) return -1;
      if (bId === formattedValuesStr) return 1;
      return 0;
    })
  : response;
    if (!response)
        response = [];
    if (type === "single"){
        response = reorderedData[0] ? reorderedData[0] : null;
        if (inputMode) {
            response = data;
        }
    }
    if (getSelectedOption)
        getSelectedOption(response);

    return response;
};
    const handleChangeDropdown = ({reason, valueKey, dropdownType = 'single', optionKey = null, alphabetic = false, parentData, isFilter = false}) => {
        const previosData = {...parentData};
        const data = {...parentData};

      if (isFromProperty) {
            if (reason && ['listing_agent_4', 'buyer_agent_4'].includes(valueKey) && reason.agent_firm && reason.agent_firm !== "0")
                data[valueKey + '_firm'] = reason.agent_firm;

            if (['listing_agent_4', 'buyer_agent_4'].includes(valueKey) && !reason)
                data[valueKey + '_firm'] = null;
        }

        if (!reason) {
            if (isFilter) delete data[valueKey];
            else {
                data[valueKey] = null;
                if (['agent-all', 'borrower'].includes(optionsType))
                    data[typeKey] = null;
            }
        } else {
            if (dropdownType === 'single') {
                // data[valueKey] = optionKey ? reason[optionKey] : reason;
                // freeSolo (customValues) entries arrive as plain strings - store them as-is
                data[valueKey] = typeof reason === 'string' ? reason : optionKey && optionKey ==="NAMES" ? reason["EMAIL"] : optionKey ? reason[optionKey] : reason;
                if (['agent-all', 'borrower'].includes(optionsType))
                    data[typeKey] = reason.groupedBy;
            } else {
                let result = '';

                if (alphabetic) reason = sortArray(reason, (optionKey ? 'name' : null));

                reason.forEach((el, index) => {
                    result += (index !== 0 ? ',' : '') + (optionKey ? el[optionKey] : el);
                });

                if (alphabetic) data[valueKey] = result.slice(0, -1);
                else data[valueKey] = result;
            }
        }

        handleParentChange(data, optionsType, (reason ? (typeof reason === 'string' ? reason : reason[optionKey ==="NAMES" ? reason["EMAIL"] : optionKey ]) : ''), valueKey, typeKey, reason, previosData);
    };

    const handleChange = (key, value) => {
        handleInputParentChange(key, value);
    };

    const filterOptions = (options, state) => {
        // MUI stringifies each option via state.getOptionLabel and calls .toLowerCase() on it.
        // Contacts with every name field null used to yield a non-string label and crash the panel.
        const safeState = {
            ...state,
            getOptionLabel: (option) => {
                const label = state && state.getOptionLabel ? state.getOptionLabel(option) : getOptionLabel(option);
                return typeof label === 'string' ? label : '';
            }
        };
        const results = defaultFilterOptions(options, safeState);
        if (optionsType === 'firm')
            options.forEach((option, index) => {
                if (!Object.keys(option).length)
                    options.splice(index, 1);
            });

        if (['agent', 'buyer', 'seller', 'firm', 'lender', 'agent-all', 'borrower'].includes(optionsType) && !results.length && withAddNew)
            return [
                <div className='no-options-container' onClick={(e) => e.stopPropagation()}>
                    No results found
                    <div className='add-new'
                         onClick={(e) => {
                             if (optionsType === 'firm' && hasDrawer) addNewItem();
                             else if (optionsType === 'borrower') addNewItem(valueKey);
                             else addNewItem(valueKey, 'buyer', index);

                             const popper = document.getElementsByClassName('MuiAutocomplete-popper');
                             if (popper && popper[0]) popper[0].style.display = 'none';

                             e.stopPropagation();
                         }}>Add new {optionsType === 'agent-all' ? 'agent' :
                        optionsType === 'borrower' ? 'buyer' : optionsType === "firm" ? "company": optionsType === 'agent' ? "agent" : optionsType === 'seller' || 'buyer' ? "investor" : optionsType}
                    </div>
                    {
                        optionsType === 'borrower' &&
                        <div className='add-new'
                             onClick={(e) => {
                                 addNewItem(valueKey, 'seller', index);

                                 const popper = document.getElementsByClassName('MuiAutocomplete-popper');
                                 if (popper && popper[0]) popper[0].style.display = 'none';

                                 e.stopPropagation();
                             }}>
                            Add new Investor
                        </div>
                    }
                </div>
            ];

        // freeSolo dropdowns accept the typed text as a new value
        if (!results.length && customValues)
            return [
                <div className='no-options-container'
                     onClick={(e) => e.stopPropagation()}>
                    {
                        state.inputValue && state.inputValue.trim()
                            ? `No results found. Press Enter to add "${state.inputValue.trim()}"`
                            : 'No results found'
                    }
                </div>
            ];

        if (!results.length && !inputMode)
            return [
                <div className='no-options-container'
                     onClick={(e) => e.stopPropagation()}>
                    No results found
                </div>
            ];
        return results;
    };

    let values = getValuesForDropdown(value, optionList, optionKey, dropdownType);
    // Plain-string option lists store the label itself as the value, so a value that is
    // no longer in the list is still safe to display. Id-based lists (agent, firm, buyer,
    // seller, tenant, lender, ...) store row ids, which must never be shown raw.
    const isPlainValueList = Array.isArray(optionList)
        && optionList.length > 0
        && optionList.every((option) => typeof option === 'string');

    // Values written by an upload or left behind by a type/category switch can fall
    // outside the current option list; show them rather than rendering a blank field.
    const getUnmatchedValues = (matched) => {
        if (!isPlainValueList || !value || typeof value !== 'string') return [];
        const matchedValues = (Array.isArray(matched) ? matched : [matched])
            .filter(Boolean)
            .map((el) => String(el));
        return value.split(',')
            .map((el) => el.trim())
            .filter((el) => el && !['null', 'undefined', 'NaN'].includes(el))
            .filter((el) => !matchedValues.includes(el));
    };

    const getFormattedValues = () => {
        if (value && Array.isArray(values))
            return values
                .map((el) => getOptionLabel(el))
                .filter((label) => label)       // Ensure non-empty labels are included
                .concat(getUnmatchedValues(values))
                .join(', ') + (fillText ? fillText : '');
        if (value && !inputMode) {
            const label = getOptionLabel(values) || getUnmatchedValues(values).join(', ');
            return `${label}${fillText ? fillText : ''}`;
        }
        if (value  && inputMode){
            return value == 'Interest Only' ? value :`${value}${fillText ? fillText:''}`;
        }
        return '-';
    };

    const rest = {};
    if (groupBy)
        rest.groupBy = (option) => {
            return option.groupedBy;
        };

    return (
        <div className={`dropdown-container${viewMode ? ' view-mode' : ''} ${className}`}>
            {
                viewMode && tooltip &&
                <span className={`tooltip-new ${tooltipPosition ? tooltipPosition:''}`}>{tooltip}</span>
            }
            {
                !viewMode &&
                <Autocomplete className={theme + (dropdownType === 'multiple' ? ' multiple' : '')}
                              multiple={dropdownType === 'multiple'}
                              disabled={disabled}
                              fullWidth
                              getOptionLabel={(option) => getOptionLabel(option)}
                              options={optionList}
                              getOptionDisabled={(option) => {
                                  // Disable if firmName matches
                                  if (firmName != null && (option.NAME === firmName || option.NAME === "   " + firmName)) {
                                      return true;
                                  }
                                  // Disable if team member is already selected in another dropdown
                                  if (optionsType === 'team-members' && selectedTeamMembers && selectedTeamMembers.length > 0) {
                                      return selectedTeamMembers.includes(option.EMAIL);
                                  }
                                  return false;
                              }}
                              value={values}                              
                              openOnFocus={openOnFocus}
                              id={id}
                              onFocus={handleInputFocus}
                              renderInput={(params) =>
                                  <TextField {...params}
                                             label={label}
                                             required={required}
                                             placeholder={placeholder}
                                             variant="outlined"
                                             onChange={inputMode ? (event) => {
                                                values = event.target.value;
                                                handleChangeDropdown({reason: event.target.value, valueKey, dropdownType, optionKey, parentData: data, isFilter})
                                              } : (event) => {}}
                                  />}
                              renderTags={(tagValue, getTagProps) =>
                                  tagValue.map((option, index) =>
                                      <Chip key={index}
                                            {...getTagProps({index})}
                                            deleteIcon={<div className='chip-remove-icon' dangerouslySetInnerHTML={{__html: removeCircle}}/>}
                                            label={getOptionLabel(option)}/>
                                  )}
                              onChange={(event, reason) => handleChangeDropdown({reason, valueKey, dropdownType, optionKey, parentData: data, isFilter})}
                              popupIcon={<div className='dropdown-icon arrow' dangerouslySetInnerHTML={{__html: arrow}}/>}
                              closeIcon={<div className='dropdown-icon' dangerouslySetInnerHTML={{__html: close}}/>}
                              filterOptions={(options, state) => filterOptions(options, state)}
                              freeSolo={customValues ? true : false}
                              autoSelect={autoSelect}
                              forcePopupIcon={customValues ? true : 'auto'}
                              {...rest}
                />
            }
            {
                viewMode &&
                <div className={`view-mode-container ${viewClassName}`}>
                    {
                        (!['status'].includes(optionsType) || isOffMarket || 'null')&&
                        <label className='view-mode-label'>{label}</label>
                    }
                    <div className={deleted ? "view-mode-deleted" : ""}>
                        {
                            ['status'].includes(optionsType) && !label &&
                            <span className='view-mode-label status'>Status</span>
                        }
                        {getFormattedValues()}
                    </div>
                </div>
            }
            {
                hasAgentPercent &&
                <div className={`agent-percent-container${percentLabel ? ' has-label' : '' }`}>
                    <Input type='text'
                           valueType='agent-percent'
                           name={percentKey}
                           value={data[percentKey] || ''}
                           label={percentLabel}
                           viewMode={viewMode}
                           deleted={deleted}
                           disabled={disabled}
                           decimals={percentDecimals}
                           handleParentChange={handleChange}
                    />
                </div>
            }
        </div>
    )
};

Dropdown.propTypes = {
    id: PropTypes.string,
    dropdownType: PropTypes.oneOf(['single', 'multiple']),
    options: PropTypes.arrayOf(PropTypes.object),
    optionsType: PropTypes.oneOf(['status', 'source', 'states', 'type', 'transaction', 'category', 'lease', 'market', 'buyer-market', 'subcategorySTNL', 'subcategoryMT', 'subcategoryIndustrialSTNLMT', 'singleTenantOffice', 'multiTenantOffice', 'superUsers', 'profiles', 'buyerStatus', 'agent', 'buyer', 'firm', 'seller', 'team', 'tenant', 'lender', 'checkbox', 'status-financing', 'loan', 'agent-all', 'borrower', 'filters','team-members', 'sellerStatus','loanquotes-amortization','estimatedPrice', 'referralType', 'confirmType','roles','territory', 'territoryMarket', 'productType','title-company']).isRequired,
    optionKey: PropTypes.string,
    optionLabelKey: PropTypes.string,
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    percentKey: PropTypes.string,
    firmName: PropTypes.string,
    label: PropTypes.string,
    percentLabel: PropTypes.string,
    data: PropTypes.object,
    hasAgentPercent: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    handleInputParentChange: PropTypes.func,
    disabled: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    withAddNew: PropTypes.bool,
    isFilter: PropTypes.bool,
    groupBy: PropTypes.bool,
    theme: PropTypes.oneOf(['default', 'white', 'dark', 'tracking', 'no-border']),
    placeholder: PropTypes.string,
    hasDrawer: PropTypes.bool,
    deleted: PropTypes.bool,
    typeKey: PropTypes.string,
    typeValue: PropTypes.string,
    getSelectedOption: PropTypes.func,
    className: PropTypes.string,
    viewClassName: PropTypes.string,
    fillText: PropTypes.string,
    index: PropTypes.number,
    tooltip: PropTypes.string,    
    tooltipPosition: PropTypes.oneOf(['up','down']),
    handleInputFocus: PropTypes.func,
    openOnFocus: PropTypes.bool,
    customValues: PropTypes.bool,
    autoSelect: PropTypes.bool
};

export default Dropdown;
